<template>
  <div class="password-expired-container">
    <div class="p-16 border border-solid shadow rounded-zt-md bg-white">
      <div class="password-expired-company-logo w-3/4 mx-auto mb-16">
        <img :src="logoURL" alt="Tu Recibo" />
      </div>
      <div class="flex flex-column justify-center items-center">
        <div
          class="w-32 h-32 bg-zt-success flex justify-center items-center rounded-full mb-12"
        >
          <img
            src="../../../../public/assets/images/check-success.svg"
            alt="check-success"
          />
        </div>
        <div class="w-3/4 text-center mb-6">
          <p class="success-message text-2xl">
            {{ $t('message.passwordExpired.success.success_message') }}
          </p>
        </div>
        <div class="w-3/5 text-center mb-16">
          <p class="text-lg">
            {{ $t('message.passwordExpired.success.pls_go_back') }}
          </p>
        </div>
        <zt-button
          @click="backToLogin"
          class="w-11/12 py-4"
          data-vs-button="button-pass-success-back-login"
        >
          {{ $t('message.passwordExpired.success.go_back_btn') }}
        </zt-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PasswordSuccess',
  data() {
    return {
      logoURL: `${window.sichern.cdnURL}/media/login/Login-Logo.png`
    }
  },
  methods: {
    backToLogin() {
      this.$emit('backToLogin')
    }
  }
}
</script>

<style lang="scss" scoped>
.success-message {
  color: #0081c6;
}
</style>
